import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { RecommendedProductModel } from "@NA/Services/ADIRecommendedProduct";
import ADICategoryRecommendedProductsState from "@NA/Store/Data/ADICategoryRecommendedProductState";
import { Draft } from "immer";

const initialState: ADICategoryRecommendedProductsState = {
    isLoading: false,
    CategoryRecommendedProductsData: null,
};

const reducer = {
    "Custom/BeginLoadCategoryRecommendedProducts": (
        draft: Draft<ADICategoryRecommendedProductsState>,
        action: { result: RecommendedProductModel },
    ) => {
        draft.isLoading = true;
        draft.CategoryRecommendedProductsData = null;
    },
    "Custom/CompleteLoadCategoryRecommendedProducts": (
        draft: Draft<ADICategoryRecommendedProductsState>,
        action: { recommendedProduct: RecommendedProductModel[] },
    ) => {
        draft.isLoading = false;
        draft.CategoryRecommendedProductsData = action.recommendedProduct;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
